import { render, staticRenderFns } from "./StartData.vue?vue&type=template&id=c4178774&"
import script from "./StartData.vue?vue&type=script&lang=js&"
export * from "./StartData.vue?vue&type=script&lang=js&"
import style0 from "./StartData.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports